export default __webpack_public_path__ + "static/media/landing-page-bg.33a756de.webp";